import { GroupContextState } from '../hooks/groupContextContext';

import { isCustomerContextType, isSupplierContextType } from './groupContextTypeUtils';

export const getGroupContextCompanySearch = ({ companyIds, type }: GroupContextState) => {
    if (isCustomerContextType(type) && companyIds.length > 0) {
        return {
            customerIds: companyIds,
            supplierIds: [],
        };
    }

    if (isSupplierContextType(type) && companyIds.length > 0) {
        return {
            customerIds: [],
            supplierIds: companyIds,
        };
    }

    return undefined;
};

export const getGroupContextCustomerCompanySearch = ({ companyIds, type }: GroupContextState) => {
    if (isCustomerContextType(type) && companyIds.length > 0) {
        return {
            customerIds: companyIds,
        };
    }

    return undefined;
};

export const getGroupContextCustomerGroupSearch = ({ groupId, type }: GroupContextState) => {
    if (isCustomerContextType(type) && groupId) {
        return {
            customerGroupIds: [groupId],
        };
    }

    return undefined;
};

export const getGroupContextCustomerDemandSearch = ({ groupId, type }: GroupContextState) => {
    if (isCustomerContextType(type) && groupId) {
        return {
            groupId,
        };
    }

    return undefined;
};
